export default Object.freeze({
  IsActivated: "IsActivated",
  Success: "Success",
  InReview: "IN-REVIEW",
  OnboardingRequired:
    "Hello! You need to complete your Onboarding to access this feature",
  Failed: "Failed",
  LIMIT_EXCEEDED:
    "Account limit is exceeded for this transaction, kindly contact the Admin",
  TokenSent: "Token Sent",
  RouteParams: "RouteParams",
  business: "business",
  walletBalance: "walletBalance",
  TransactionsSummary: "TransactionsSummary",
  walleTransferLimit: "walleTransferLimit",
  OfflineTransactions: "OfflineTransactions",
  WalletTransactions: "WalletTransactions",
  WeekSummary: "WeekSummary",
  NewBeneficiaryPayload: "NewBeneficiaryPayload",
  SavedBeneficiaryPayload: "SavedBeneficiaryPayload",
  TransferPayload: "TRANSFERPAYLOAD",
  Banks: "Banks",
  Sent: "Sent",
  INVALID_PIN: "Invalid Pin",
  SET_UP_PIN: "Please set your pin to use this feature",
  LOW_WALLET_BALANCE: "Account balance is low, kindly top up",
  Beneficiaries: "Beneficiaries",
  MakerCheckerUserType: {
    REQUESTER: "REQUESTER",
    REVIEWER: "REVIEWER",
    APPROVER: "APPROVER",
  },
  CATEGORY: {
    WALLET: "WALLET",
    OFFLINE: "OFFLINE",
  },
  TRANSACTION_TYPE: {
    EXPENSE: "EXPENSE",
    INCOME: "INCOME",
    INCOME_DEBT: "INCOME-DEBT",
    EXPENSE_DEBT: "EXPENSE-DEBT",
  },
  STATUS: {
    APPROVED: "APPROVED",
    PENDING: "PENDING",
    VOID: "VOID",
    FAILED: "FAILED",
    PAID: "PAID",
    IGNORE: "IGNORED",
    IN_REVIEW: "IN REVIEW",
    REVIEWED: "REVIEWED",
    PARTIALLY_REVIEWED: "PARTIALLY REVIEWED",
    REQUEST_CHANGE: "REQUEST CHANGE",
    PROCESSING: "PROCESSING",
    REVERSED: "REVERSED",
  },
  TRANSACTION_STATUS: {
    PAID: "FULLY-PAID",
    VOID: "VOID",
    UNPAID: "UNPAID",
    PARTIALLY_PAID: "PARTIALLY-PAID",
  },
  QUOTATION_STATUS: {
    DRAFT: "DRAFT",
    VOID: "VOID",
    ORDERED: "ORDERED",
    EXPIRED: "EXPIRED",
  },
  MissingWithdrawalAccount: "Kindly Setup Your Withdrawal Account",
  RoutePath: "RoutePath",
  Routes: {
    Home: "/",
    Login: "/auth/login",
    SignUp: "/signup",
    ForgetPassword: "/forgot-password",
    Otp: "/otp",
    ResetPassword: "/reset-password",
    AdminDashboard: "/dashboard",
    Transaction: "/transaction",
    InvoiceReceipt: "/invoice-receipt",
    Admin: "/admin",
    Wallet: "/wallet",
    // Admin: '/admin',
    WalletTransactions: "/wallet-transactions",
    CreateInflow: "/create-in-flow",
    CreateOutflow: "/create-out-flow",
    SignedUpBusineses: "/signed-businesses",
    Bills: "/bills",
    ReconcileBills: "/recon-bills",
    ExchangeRate: "/exchange-rate",
    Audit: "/audit",
    Settings: "/settings",
    BusinessCategory: "/business-category",
    FaqsCategory: "/faqs-category",
    Faqs: "/faqs",
    ChargeAnalysis: "/charge-analysis",
    ExpenseCategory: "/expense-category",
    Subscription: "/subscription",
    ApproveBank: "/approve-bank-account",
    BankAccountList: "/bank-account-list",
    Charge: "/charge",
    Support: "/support",
    ExchangeTransactions: "/exchange-transactions",
    FeedbackRes: "/feedback-response",
    FeedbackConfig: "/feedback-configuration",
    SplitPayment: "/split-payment",
    KudaTransactions: "/kuda-transactions",
    ProvidusTransactions: "/providus-transactions",
    FashCreatives: "/fash-creatives",
    FashPublicCatalogue: "/fash-public-catalogue",
    Payout: "/payout",
    News: "/news",
    Marketers: "/marketers",
    MarketersAnalysis: "/marketers-analysis",
    ViewMoreNews: "/view-more-news",
    Broadcast: "/broadcast",
    CreateBroadcast: "/create-broadcast",
    UpdateBroadcast: "/update-broadcast",
    CloneBroadcast: "/clone-broadcast",
    ViewMoreBroadcast: "/view-more-broadcast",
    ForeignBankAccounts: "/foreign-bank-accounts",
    FashBusinesses: "/fash-businesses",
    StyleCategories: "/style-categories",
    MoneyExAds: "/moneyex-ads",
    MoneyExUsers: "/moneyex-users",
    MoneyExLimit: "/moneyex-limit",
    MoneyExP2POrders: "/moneyex-p2p-orders",
    MoneyExExpressOrders: "/moneyex-express-orders",
    PaymentMethod: "/payment-method",
    Prospects: "/prospects",
    Themes: "/themes",
    Providers: "/providers",
    Competitions: "/competitions",
    Votes: "/votes",
    Participants: "/participants",
  },
  IsOnBoardingDone: "IsOnBoardingDone",
  OtpType: {
    FORGETPASSWORD: "FORGETPASSWORD",
    ONBOARDING: "ONBOARDING",
    BVNONBOARDING: "BVNONBOARDING",
  },
});
